import * as React from "react";
import { Fragment } from "react";
import { Grid, Typography } from "@mui/material";
import CopyrightIcon from '@mui/icons-material/Copyright';
import { FooterStyles } from "./footerStyles";

const Footer = () => {

    const {
        footer,
        site,
        copyRightText,
        icon
    } = FooterStyles().classes;

    return (
        <Fragment>
            <Grid container className={footer}>
                <Grid item>
                    <Grid container className={copyRightText}>
                        <Typography className={copyRightText}>Copyright
                            <CopyrightIcon className={icon} />
                             All Rights Reserved {new Date().getFullYear()}</Typography>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container className={copyRightText}>
                        <Typography className={site} >Terms and Conditions</Typography>
                        <Typography className={copyRightText} sx={{ padding: "0px 20px", borderRight: "1px solid white" }} >Privacy Policy</Typography>
                        <Typography className={copyRightText} sx={{ padding: "0px 0px 0px 20px" }}>User Agreement</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Fragment>
    );
};

export default Footer;